<template>
  <div class="dv-decoration-5new" :ref="ref">
    <svg width="100%" height="100%">
        <defs>
            <linearGradient id="ant" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" :stop-color="mergedColor[1]" />
                <stop offset="50%" :stop-color="mergedColor[0]" />
                <stop offset="100%" :stop-color="mergedColor[1]" />
            </linearGradient>
        </defs>
      <polyline
        fill="transparent"
        stroke="url(#ant)"
        stroke-width="3"
        :points="line1Points"
      >
        <!-- <animate
          attributeName="stroke-dasharray"
          attributeType="XML"
          :from="`0, ${line1Length / 2}, 0, ${line1Length / 2}`"
          :to="`0, 0, ${line1Length}, 0`"
          dur="1.2s"
          begin="0s"
          calcMode="spline"
          keyTimes="0;1"
          keySplines="0.4,1,0.49,0.98"
          repeatCount="indefinite"
        /> -->
      </polyline>
    </svg>
  </div>
</template>

<script>
import autoResize from '@jiaminghi/data-view/lib/mixin/autoResize'

import { getPolylineLength } from '@jiaminghi/charts/lib/util'

import { deepMerge } from '@jiaminghi/charts/lib/util/index'

import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'

export default {
  name: 'Decoration5new',
  mixins: [autoResize],
  props: {
    color: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      ref: 'decoration-5new',

      line1Points: '',

      line1Length: 0,

      defaultColor: ['#3f96a5', '#3f96a5'],

      mergedColor: []
    }
  },
  watch: {
    color () {
      const { mergeColor } = this

      mergeColor()
    }
  },
  methods: {
    afterAutoResizeMixinInit () {
      const { calcSVGData } = this

      calcSVGData()
    },
    calcSVGData () {
      const { width, height } = this

      let line1Points = [
        [0, height * 0.2], [width * 0.36, height * 0.2],
        [width * 0.37, height * 0.9], [width * 0.63, height * 0.9],  [width * 0.64, height * 0.2], [width, height * 0.2]
      ]

      const line1Length = getPolylineLength(line1Points)

      line1Points = line1Points.map(point => point.join(',')).join(' ')

      this.line1Points = line1Points

      this.line1Length = line1Length
    },
    onResize () {
      const { calcSVGData } = this

      calcSVGData()
    },
    mergeColor () {
      const { color, defaultColor } = this

      this.mergedColor = deepMerge(deepClone(defaultColor, true), color || [])
    }
  },
  mounted () {
    const { mergeColor } = this

    mergeColor()
  }
}
</script>
<style lang="scss" type="text/scss">
    .dv-decoration-5 {
        width: 100%;
        height: 100%;
    }

</style>